(ns app.front.view.group.admin.fees.schedule.ui)

(def h2 :h2.mb-2.text-sm.font-bold.leading-none)
(def p :p.mb-4.p-0.leading-tight)
(def grid-3 :div.grid.grid-cols-3.gap-4.mb-4)
(def grid-4 :div.grid.grid-cols-4.gap-4.mb-4)
